import React from "react";
import SIZE from "../../../../../componets/ENUMS/SIZE";

export default class LookUpData extends React.Component {
  render() {
    const { Bs, VARIANT, Icon, o2FSForm, docs, set } = this.props;
    return (
      <>
        <Bs row className="mt-4">
          <Bs col xs={12}>
            <Bs card bg={VARIANT.WHITE}>
              <Bs cardheader className="bg-white">
                <Bs row>
                  <Bs
                    col
                    xs={12}
                    className="d-flex justify-content-around align-items-center"
                  >
                    <Bs strong>Zakázky</Bs>
                    <Bs small className="text-muted">
                      Počet zakázek ({docs?.length})
                    </Bs>
                    <Bs button size={SIZE.SM} variant={VARIANT.PRIMARY} disabled={o2FSForm.loading} onClick={() => set({o2FSForm: {open: true}})}>
                        {o2FSForm.loading? <Bs brtxspin /> : "O2 FS"}
                    </Bs>
                    <Bs button size={SIZE.SM} variant={VARIANT.SUCCESS} onClick={() => set({docDetailForm: {data: {DocNo: -1}, open: true, idx: -1}})}>
                        Přidat
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </Bs>
        <Bs row className="mt-2">
          {docs.map((e, idx) => (
            <Bs col xs={12} className="mb-2">
              <Bs card bg={VARIANT.WHITE}>
                <Bs cardheader className="bg-white">
                  <Bs row>
                    <Bs col xs={9}>
                      {e?.DocNo}
                    </Bs>
                    <Bs col xs={3} className="d-flex justify-content-end">
                      <Icon
                        aioutlinesolution
                        data-tip="Vytisknout 'Smlouvu o provedení opravy'"
                        className="c-secondary cursor-pointer me-2 fs-20"
                      />
                      <Icon
                        aioutlineprinter
                        data-tip="Vytisknout 'Interní štítek'"
                        className="c-secondary cursor-pointer me-4 fs-20"
                      />
                      <Icon
                        aioutlinefolderopen
                        data-tip="Otevřít detaily"
                        className="c-secondary cursor-pointer fs-20"
                        onClick={() =>
                          set({
                            docDetailForm: {
                              open: true,
                              data: e,
                              idx: idx,
                            },
                          })
                        }
                      />
                    </Bs>
                  </Bs>
                </Bs>
                <Bs cardbody>
                  <Bs row>
                    <Bs col xs={4}>
                      <Bs small>
                        <Bs strong>{e?.FirmName}</Bs>
                      </Bs>
                    </Bs>
                    <Bs col xs={4}>
                      <Bs small className="text-muted">
                        {e?.DeviceSN}
                      </Bs>
                    </Bs>
                    <Bs col xs={4}>
                      <Bs small className="text-muted">
                        {new Date(e?.DatProdej).toLocaleDateString()}
                      </Bs>
                    </Bs>
                  </Bs>
                  <Bs row>
                    <Bs col xs={4}>
                      <Bs small className="text-muted">
                        {e?.TypeName}
                      </Bs>
                    </Bs>
                    <Bs col xs={4}>
                      <Bs small className="text-muted">
                        {e?.ProductCodeSN}
                      </Bs>
                    </Bs>
                    <Bs col xs={4}>
                      <Bs small className="text-muted">
                        {new Date(e?.DatExtPr).toLocaleDateString()}
                      </Bs>
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          ))}
        </Bs>
      </>
    );
  }
}
